import { IURIPartial, TURIScheme } from '@cian/http-api/shared/URI/IURI';

export function getHttpRequestUri(stringUrl: string): IURIPartial {
  const url = new URL(stringUrl);

  return { host: url.host, path: url.pathname, scheme: url.protocol.replace(/[^a-zA-Z]+/g, '') as TURIScheme };
}
